import React, { useState } from 'react';
import { Scissors, Copy, CheckCircle } from 'lucide-react';
import { API } from '../App';

export function ClipButton({ frayId, voice, phase, text, sequenceId }) {
  const [clipped, setClipped] = useState(false);

  const handleClip = async () => {
    try {
      const res = await API.post(`/api/frays/${frayId}/clips`, { voice, phase, text: text?.slice(0, 500), start_seq: sequenceId });
      const shareUrl = `${window.location.origin}/clip/${res.data.share_token}`;
      navigator.clipboard.writeText(shareUrl);
      setClipped(true);
      setTimeout(() => setClipped(false), 2000);
    } catch {}
  };

  return (
    <button onClick={handleClip} className="text-[#A0A0A0] hover:text-[#FF4D00] opacity-0 group-hover:opacity-100 transition-opacity" title="Clip & Share">
      {clipped ? <CheckCircle className="w-3 h-3 text-[#22C55E]" /> : <Scissors className="w-3 h-3" />}
    </button>
  );
}

export function ClipFromTranscript({ frayId, voice, phase, text }) {
  const [clipped, setClipped] = useState(false);

  const handleClip = async () => {
    try {
      const res = await API.post(`/api/frays/${frayId}/clips`, { voice, phase, text: text?.slice(0, 500) });
      const shareUrl = `${window.location.origin}/clip/${res.data.share_token}`;
      navigator.clipboard.writeText(shareUrl);
      setClipped(true);
      setTimeout(() => setClipped(false), 2000);
    } catch {}
  };

  return (
    <button onClick={handleClip} className="text-[#A0A0A0] hover:text-[#FF4D00] transition-colors" title="Clip & share this section">
      {clipped ? <><CheckCircle className="w-3 h-3 inline mr-1 text-[#22C55E]" />Copied link</> : <><Scissors className="w-3 h-3 inline mr-1" />Clip</>}
    </button>
  );
}
